<app-dialog-heading [heading]="'Are you sure?'"></app-dialog-heading>
<div class="dialog-content">
  <p class="text-center">{{confirmationMessage}}</p>
</div>
<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button [mat-dialog-close]="false" color="warn">No</button>
  <button class="dialog-button" mat-raised-button [mat-dialog-close]="true" color="primary">Yes</button>
</mat-dialog-actions>
